import React from "react";
import PropTypes from "prop-types";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import DeleteIcon from "@material-ui/icons/Delete";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRunning } from "@fortawesome/free-solid-svg-icons";
import { faShoePrints } from "@fortawesome/free-solid-svg-icons";

const LogResult = (props) => {
  const useStyles = makeStyles({
    root: {
      width: 275,
      margin: ".4rem",
    },
    titleWrapper: {
      textOverflow: "ellipsis",
      width: 210,
      overflow: "hidden",
    },
    title: {
      fontSize: 24,
    },
    pos: {
      marginBottom: 12,
    },
    deleteWrapper: {
      position: "relative",
    },
    active: {
      background:
        "linear-gradient(90deg, rgba(0,212,255,1) 0%, rgba(0,212,255,1) 49%, rgba(51,128,177,1) 100%);",
    },
    inactive: {
      backgroundColor: "#e0f8ff",
    },
    deleteBtn: {
      backgroundColor: "#e74c3c",
      color: "white",
      border: "none",
      borderRadius: "50%",
      fontWeight: 700,
      padding: "5px 8px",
      width: 40,
      height: 40,
      cursor: "pointer",
      position: "absolute",
      top: "-7px",
      right: "-7px",
    },
    iconDivider: {
      display: 'inline-block',
      paddingLeft: '10px'
    },
    optionWrapper: {
      fontSize: 12,
    },
    optionIconShoe: {
      marginLeft: '7px',
      fontSize: "110%",
    },
    optionIconInsole: {
      marginLeft: '7px',
      fontSize: "90%",
    },
  });

  const classes = useStyles();
  const log = props.log;

  // options
  const logOptions = [];
  if (log.isNewShoe) logOptions.push("New shoes");
  if (log.isNewInsole) logOptions.push("New insoles");

  return (
    <Card
      className={`${classes.root} ${
        props.isActive ? classes.active : classes.inactive
      }`}
    >
      <CardContent>
        <Grid container justify="space-between">
          <Grid item>
            <div className={classes.titleWrapper}>
              <Typography noWrap className={classes.title} variant="h5">
                {log.location}
              </Typography>
            </div>
            <Typography
              className={classes.pos}
              variant="subtitle2"
              color="textSecondary"
            >
              {moment(log.date).format("MM/DD/YYYY")}
            </Typography>
            <div>
              Distance: {log.distance}
              <div className={classes.iconDivider}>
              {log.isNewShoe && (
                <FontAwesomeIcon
                  icon={faRunning}
                  className={classes.optionIconShoe}
                />
              )}
              {log.isNewInsole && (
              <FontAwesomeIcon
                  icon={faShoePrints}
                  className={classes.optionIconInsole}
                />
                )}
                </div>
            </div>
          </Grid>
          {props.isActive ? (
            <Grid item className={classes.deleteWrapper}>
              <CardActions>
                <button
                  className={classes.deleteBtn}
                  onClick={() => props.delete(log.id)}
                >
                  <DeleteIcon />
                </button>
              </CardActions>
            </Grid>
          ) : null}
        </Grid>
      </CardContent>
    </Card>
  );
};

LogResult.defaultProps = {
  isActive: true,
};

LogResult.propTypes = {
  log: PropTypes.object.isRequired,
  delete: PropTypes.func,
  isActive: PropTypes.bool,
};

export default LogResult;
